import { createAction, props } from '@ngrx/store';
import { PaymentPreviewV1Response } from '@arc/unified-payments-frontend/shared-payment';
import { HttpErrorResponse } from '@angular/common/http';

export const PoiStripeResultIntlPaymentPreviewActions = {
  loadPaymentPreviewSuccess: createAction(
    '[POI Intl Stripe Result] Load Payment Preview Success',
    props<{ payload: PaymentPreviewV1Response }>(),
  ),
  loadPaymentPreviewError: createAction(
    '[POI Intl Stripe Result] Load Payment Preview Error',
    props<{ error: HttpErrorResponse }>(),
  ),
};
